import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Spinner } from '@tink/core/src/components/atoms/Spinner/Spinner';
import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { ScreenWrapper } from '../../../../components/atoms/ScreenWrapper/ScreenWrapper';
import { ContentBody } from '../../../../components/atoms/ContentBody/ContentBody';
import { Text } from '../../../../components/atoms/Text/Text';
import { messages } from '../messages';

export type RedirectingBackToScreenProps = {
  clientName: string;
};

export const RedirectingBackToScreen: React.FC<RedirectingBackToScreenProps> = ({ clientName }) => {
  const isClientNameAbbreviated = clientName.endsWith('.');

  return (
    <ScreenWrapper>
      <ContentBody centerHorizontally centerVertically>
        <Box mb="normal">
          <Spinner />
        </Box>
        <Text>
          <FormattedMessage
            {...messages.redirectingBack}
            values={{ clientName, isAbbreviated: isClientNameAbbreviated }}
          />
        </Text>
      </ContentBody>
    </ScreenWrapper>
  );
};
